var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path, _path2, _path3, _path4, _path5, _path6, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg5 = function Svg5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 0.074,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.846,
    y: 14.844,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 24.074,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.846,
    y: 20.998,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 6.229,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 30.229,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 17.92,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.846,
    y: 17.92,
    width: 13.539,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 41.537,
    y: 27.15,
    width: 13.539,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 6.229,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 3.15,
    width: 13.539,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 27.15,
    width: 11.077,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.922 54.002c0-.215.174-.389.389-.389h10.688v2.462H1.31a.389.389 0 0 1-.39-.389v-1.684Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "M12 53.613h25.846v2.462H12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M37.846 53.613h4.923v2.462h-4.923z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.77 53.613h11.918c.215 0 .39.174.39.39v1.683a.389.389 0 0 1-.39.389H42.77v-2.462Z",
    fill: "#DDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.846 57.692c0-.214.173-.387.387-.387h4.536v2.461h-4.536a.388.388 0 0 1-.387-.387v-1.687ZM37.846 61.386c0-.214.173-.388.387-.388h4.536v2.462h-4.536a.388.388 0 0 1-.387-.388v-1.686Z",
    fill: "#B3B3B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.77 57.305h11.918c.215 0 .39.174.39.389v1.683a.389.389 0 0 1-.39.39H42.77v-2.462ZM42.77 60.998h11.918c.215 0 .39.174.39.389v1.684a.389.389 0 0 1-.39.389H42.77v-2.462Z",
    fill: "#DDD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 33.305,
    width: 54.577,
    height: 2.209,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 40.69,
    width: 54.577,
    height: 2.209,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 9.92,
    width: 54.154,
    height: 3.692,
    rx: 0.389,
    fill: "#DDD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 36.998,
    width: 8.615,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36.998,
    width: 3.077,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 16.922,
    y: 36.998,
    width: 3.692,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 22.461,
    y: 36.998,
    width: 3.077,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 40.922,
    y: 36.998,
    width: 5.538,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 36.998,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 49.537,
    y: 36.998,
    width: 5.538,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 44.383,
    width: 8.615,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44.383,
    width: 3.077,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 16.922,
    y: 44.383,
    width: 3.692,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 22.461,
    y: 44.383,
    width: 3.077,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 40.922,
    y: 44.383,
    width: 5.538,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 44.383,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 49.537,
    y: 44.383,
    width: 5.538,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 40.922,
    y: 47.459,
    width: 5.538,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 40.922,
    y: 50.535,
    width: 5.538,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 47.459,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 50.535,
    width: 9.846,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 49.537,
    y: 47.459,
    width: 5.538,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 49.537,
    y: 50.535,
    width: 5.538,
    height: 1.846,
    rx: 0.389,
    fill: "#DDD"
  })));
};

export default Svg5;